import React from 'react';
import { ImageBackground, StyleSheet } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

import { Theme } from '@constants';

export const OnboardingBackgroundImage = ({ testID, uri, children }) => (
  <ImageBackground
    resizeMode={'cover'}
    source={{
      uri,
    }}
    style={styles.background}
    testID={testID}
  >
    <LinearGradient
      angle={259}
      angleCenter={{ x: 1, y: 1 }}
      colors={[Theme.gradients.onboarding.start, Theme.gradients.onboarding.end]}
      locations={[0, 1]}
      style={styles.backgroundGradient}
      useAngle
    >
      {children}
    </LinearGradient>
  </ImageBackground>
);

const styles = StyleSheet.create({
  background: {
    backgroundColor: Theme.gradients.onboarding.end,
    height: Theme.appHeight,
    width: Theme.appWidth,
  },
  backgroundGradient: {
    flex: 1,
    height: '100%',
    width: '100%',
  },
});
